/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

import VeeValidate, {ExtendOptions, Validator} from 'vee-validate';
import {FileSizeValidator} from '@/validators/file-size';
import Vue from 'vue';
import {state} from '@/store/modules/settings';
import LanguageService from '@/services/language';

/**
 * Validator initialisation module.
 *
 * Initialises and adds custom validation rules to vee-validate Validator.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */

// add vee-validation components
Vue.use(VeeValidate);

// add file size validation rule
Validator.extend('fileSize', FileSizeValidator, {paramNames: ['size']} as ExtendOptions);

// add additional dictionary definitions
for (const language of LanguageService.supported) {
    Validator.localize(language, {
        messages: {
            fileSize: (field: string, size: number): string => Vue.i18n.translate('item-create-form.files.error.size', {
                size: (1000000 <= size) ? `${(size / 1000000).toFixed(0)}MB` : `${(size / 1000).toFixed(0)}KB`,
            }) || '',
        },
    });
}

// configure vee-validate
const locale: string = state.language;
import(`vee-validate/dist/locale/${locale}`).catch(() => {
    return import(`vee-validate/dist/locale/en`);
}).then((translation: object) => {
    Validator.localize(state.language, translation);
});



